export default __webpack_public_path__ + "static/media/matlab.b55f26aa.png";